import { CommonModule, Location } from '@angular/common';
import { Component, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { UserService } from '../../services/user services/user.service';
import { MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { AnonymousUserService } from '../../services/user services/anonymous-user.service';


type SocialPlatform = 'Facebook' | 'Twitter' | 'LinkedIn' | 'Instagram' | string;

type IconMapping = {
  [key in 'Facebook' | 'Twitter' | 'LinkedIn' | 'Instagram' | 'default']: string;
};

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PrivacyPolicyComponent
  ]
})

export class ContactInfoComponent {

  @ViewChild('privacyPolicyOverlay') overlayTemplate!: TemplateRef<any>;
  private overlayRef: OverlayRef | null = null;

  name1: string = 'Charles Hergott';
  phone1: string = '+41 76 733 7484';
  email1: string = 'c.hergott@uav-leasing.com';
  linkedin1: string = 'charles-hergott-aerospace-ict/';
  selectedTab: string = 'contacts';
  profileImage1: string = '/assets/images/profiles/charles.jpg';
  profileImage2: string = '/assets/images/profiles/gert.jpg';
  currentSlide: number = 0;
  linkedinUsername: string = '';
  loading: boolean = false;
  deviceId!: string;
  showPrivacyPolicy: boolean = false;

  private readonly icons: IconMapping = {
    'Facebook': 'logo-facebook',
    'Twitter': 'logo-twitter',
    'LinkedIn': 'logo-linkedin',
    'Instagram': 'logo-instagram',
    'default': 'link-outline'
  };

  faqs = [
    { question: 'What is this app about?', answer: 'This app is designed to seamlessly place pictures at your current location on a map without any moderation', isOpen: false },
    { question: 'Is it free to use?', answer: 'This app is currently 100% free.', isOpen: false },
    { question: 'Why is there a timer under the picture when I click on a Map Marker?', answer: 'Moderation is peer-to-peer: each picture has a default life of 24h on the map but when other users like it, it gains 1 hour; when other users dislike it, it looses 1 hour.', isOpen: false },
    { question: 'Are there any catches/hidden strings?', answer: 'No although thats what someone would say if he had a hidden agenda :) But you can always contact the founders if you have any questions. The pictures are stored on Google Firebase in a datacenter in Europe.', isOpen: false }
  ];

  constructor(
    private _anonymousUserService: AnonymousUserService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private _dialogRef: MatDialogRef<ContactInfoComponent>
  ) { }

  ngOnInit() {
    this.getDeviceId();
  }

  getDeviceId() {
    this.deviceId = this._anonymousUserService.currentUserId;
  }

  openLinkedin(linkedinUsername: string) {
    const baseUrl = 'https://www.linkedin.com/in/';
    const url = `${baseUrl}${linkedinUsername}`;
    window.open(url, '_blank');
  }

  openWhatsApp(phone: string) {
    const cleanPhone = phone.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanPhone}`, '_blank');
  }

  openEmailProvider(email: string) {
    const mailtoLink = `mailto:${email}`;
    window.open(mailtoLink, '_self');
  }

  getSocialIcon(platform: SocialPlatform): string {
    return this.icons[platform as keyof IconMapping] || this.icons.default;
  }

  toggleAnswer(faq: any) {
    faq.isOpen = !faq.isOpen;
  }

  setSelectedTab(tab: string) {
    this.selectedTab = tab;
  }

  previousSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  openOverlay() {
    const config = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    this.overlayRef = this.overlay.create(config);

    // Use viewContainerRef instead of _injector
    const portal = new TemplatePortal(
      this.overlayTemplate,
      this.viewContainerRef
    );

    this.overlayRef.attach(portal);

    // Close on backdrop click
    this.overlayRef.backdropClick().subscribe(() => this.closeOverlay());
  }

  closeOverlay() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  goBack(): void {
    this._dialogRef.close();
  }
}
